import {
  Box,
  Card,
  Grid,
  Grow,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  TextField,
  Typography
} from '@material-ui/core'
import { AsterToggleButton, AsterToggleButtonGroup } from 'asterX-UI/Buttons/toggle-button'
import ActionModal from 'asterX-UI/Modals/ActionModal'
import { useContractStore } from 'context/ContractStore'
import { useEffect, useRef, useState } from 'react'
import { SelectPlaceholder } from 'asterX-UI/Inputs'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useSnackbar } from 'notistack'
import DateIcon from 'asterX-UI/Icons/DateIcon'
import { GRAY_COLORS } from 'asterX-UI'
import { DatePicker } from '@material-ui/pickers'
import { CollectionService } from 'lib/api/services/collection.service'
import { UploadIcon } from 'asterX-UI/Icons/UploadIcon'
import { FileIcon } from 'asterX-UI/Icons/FileIcon'
import { BlueLines } from 'asterX-UI/Icons/BlueLines'
import { DeleteIcon } from 'asterX-UI/Icons/DeleteIcon'
import { BorderLinearProgress } from '../FileContract/components/UploadFilesModal/const'
import { useStyles } from './add-events.styles'

export const actionBtnTypes = [
  { label: 'Контакт установлен', code: 'ESTABLISHED' },
  { label: 'Контакт не установлен', code: 'NOT_ESTABLISHED' }
]

export const AddEvents = ({ open, calledPhoneNumber, onClose, onCancel }) => {
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const intervalRefs = useRef({})
  const fileInputRef = useRef(null)
  const {
    contractStore: { contractAll, events, eventPhoneNumbers, statuses },
    contractStoreFunc
  } = useContractStore()

  const [activeTab, setActiveTab] = useState('ESTABLISHED')
  const [files, setFiles] = useState([])

  const isNoResult = contractAll?.events?.some(item => !item?.result)
  const selectedEvent = statuses?.list?.find(item => item?.eventTypeCode === events?.eventTypeCode)

  // const maxDate = new Date()
  // maxDate.setDate(maxDate.getDate() + 3)

  useEffect(() => {
    if (open) {
      contractStoreFunc.getPhoneNumbers()
      contractStoreFunc.getStatuses()
      if (calledPhoneNumber) {
        contractStoreFunc.setEvents(prevState => ({
          ...prevState,
          phoneNumber: calledPhoneNumber,
          eventTypeCode: 'CALL'
        }))
      }
    }
  }, [open])

  useEffect(() => {
    if (events?.eventTypeCode === 'LEGAL') {
      contractStoreFunc.handleEventsChange({
        target: { name: 'eventResultCode', value: 'HANDED_OVER_TO_COURT' }
      })
    }
  }, [events?.eventTypeCode])

  const saveWorkListFile = async () => {
    const filesData = {
      workListId: contractAll?.id,
      fileType: 'CLIENT_DOSSIER',
      downloadUrl: files?.[0]?.fileDownloadUri
    }

    await CollectionService.saveWlFile(filesData)
      .then(res => {
        if (res.data) {
          contractStoreFunc.getWlFiles(contractAll?.id)
        } else {
          enqueueSnackbar(`😿 Что-то пошло не так, статус ${res?.status}`, { variant: 'error' })
        }
      })
      .finally(() => {})
  }

  const handleEventTypeChange = e => {
    contractStoreFunc.setEvents(prevState => ({
      ...prevState,
      eventResultCode: null
    }))
    contractStoreFunc.handleEventsChange(e)
  }

  const handleClose = () => {
    onClose()
    setFiles([])
    contractStoreFunc.clearEvents()
  }

  const handleCancel = () => {
    onCancel()
    setFiles([])
    contractStoreFunc.clearEvents()
  }

  const handleChangeToggleButton = val => {
    setActiveTab(val)

    contractStoreFunc.setEvents(prevState => ({
      ...prevState,
      phoneNumber: events?.phoneNumber,
      established: val === 'ESTABLISHED',
      description: null,
      contactType: null,
      dueDate: null,
      eventTypeCode: null,
      eventResultCode: null
    }))
  }

  const handleSendEvents = async () => {
    const missingFields = []

    if (!activeTab) {
      missingFields.push('Контакт установлен/не установлен')
    }

    if (activeTab === 'ESTABLISHED') {
      if (!events?.contactType) {
        missingFields.push('Клиент')
      }
      if (!events?.eventTypeCode) {
        missingFields.push('Выбрать тип действия')
      }
      if (!events?.dueDate && events?.eventResultCode === 'PROMISE') {
        missingFields.push('Дата')
      }
      if (events?.eventResultCode === 'HANDED_OVER_TO_COURT' && !files?.[0]?.fileDownloadUri) {
        missingFields.push('загрузить досье клиента')
      }
    } else if (activeTab === 'NOT_ESTABLISHED') {
      if (!events?.eventTypeCode) {
        missingFields.push('Выбрать тип действия')
      }
      if (events?.eventTypeCode && !events?.eventResultCode) {
        missingFields.push('Выбрать результат')
      }
      if (events?.eventResultCode === 'HANDED_OVER_TO_COURT' && !files?.[0]?.fileDownloadUri) {
        missingFields.push('загрузить досье клиента')
      }
    }

    if (missingFields.length > 0) {
      enqueueSnackbar(`😿 Заполните поле(я): ${missingFields.join(', ')}`, { variant: 'info' })
      return
    }

    await contractStoreFunc.createEvents(handleClose, saveWorkListFile)
  }

  const handleUploadFile = async event => {
    const file = event.target.files?.[0]
    const data = new FormData()
    data.append('file', file)

    const res = await CollectionService.uploadFile(data)

    if (res?.data) {
      const newFile = {
        name: res?.data?.fileName,
        fileDownloadUri: res?.data?.fileDownloadUri,
        size: res?.data?.size,
        date: new Date().toLocaleDateString(),
        progress: 0
      }

      setFiles(prevFiles => [...prevFiles, newFile])

      intervalRefs.current[newFile.name] = setInterval(() => {
        setFiles(prevFiles => {
          const updatedFiles = prevFiles.map(f => {
            if (f.name === newFile.name) {
              const updatedProgress = f.progress + 20
              if (updatedProgress >= 100) {
                clearInterval(intervalRefs.current[newFile.name])
                delete intervalRefs.current[newFile.name]
                return { ...f, progress: 100 }
              }
              return { ...f, progress: updatedProgress }
            }
            return f
          })
          return updatedFiles
        })
      }, 100)
    }
  }

  const handleClick = () => {
    fileInputRef.current?.click()
  }

  const handleDelete = fileName => {
    clearInterval(intervalRefs.current[fileName])
    delete intervalRefs.current[fileName]
    setFiles(files.filter(file => file.name !== fileName))
  }

  return (
    <ActionModal
      open={open}
      onClose={handleClose}
      onCancel={handleCancel}
      title="Добавить действие"
      labelConfirm="Создать"
      onConfirm={handleSendEvents}
    >
      <Grid item container xs={12} className={classes.eventsContainer}>
        <Grid item container>
          <AsterToggleButtonGroup
            exclusive
            value={activeTab}
            onChange={(e, val) => handleChangeToggleButton(val)}
            className={classes.actionBtn}
          >
            {actionBtnTypes.map(({ label, code }, i) => (
              <AsterToggleButton key={`action-toggle-btn-${code}`} value={code}>
                {label}
              </AsterToggleButton>
            ))}
          </AsterToggleButtonGroup>
        </Grid>
        <Grid item xs={12} className={classes.item}>
          <InputLabel shrink className={classes.inputLabel}>
            Номер телефона
          </InputLabel>
          <SelectPlaceholder
            IconComponent={props => <ExpandMoreIcon {...props} style={{ margin: '0 8px 0 8px' }} />}
            value={events?.phoneNumber || null}
            name={'phoneNumber'}
            onChange={e => contractStoreFunc.handleEventsChange(e)}
            fullWidth
            placeholder={'Номер телефона'}
          >
            <MenuItem value={''}>Не выбрано</MenuItem>
            {(eventPhoneNumbers || []).map(item => (
              <MenuItem key={item} value={item}>
                {item?.toString()?.toPhone()}
              </MenuItem>
            ))}
          </SelectPlaceholder>
        </Grid>
        {activeTab === 'ESTABLISHED' && (
          <Grid item xs={12} className={classes.item}>
            <InputLabel shrink className={classes.inputLabel}>
              Клиент *
            </InputLabel>
            <SelectPlaceholder
              IconComponent={props => <ExpandMoreIcon {...props} style={{ margin: '0 8px 0 8px' }} />}
              value={events?.contactType || null}
              name={'contactType'}
              placeholder={'Не выбрано'}
              onChange={e => contractStoreFunc.handleEventsChange(e)}
              fullWidth
            >
              <MenuItem value={''}>Не выбрано</MenuItem>
              <MenuItem value={'CLIENT'}>Клиент</MenuItem>
              <MenuItem value={'THIRD_PARTY'}>Третье лицо</MenuItem>
            </SelectPlaceholder>
          </Grid>
        )}
        <Grid item xs={12} className={classes.item}>
          <InputLabel shrink className={classes.inputLabel}>
            Выбрать тип действия *
          </InputLabel>
          <SelectPlaceholder
            IconComponent={props => <ExpandMoreIcon {...props} style={{ margin: '0 8px 0 8px' }} />}
            value={events?.eventTypeCode || null}
            name={'eventTypeCode'}
            onChange={handleEventTypeChange}
            fullWidth
            placeholder={'Тип действия'}
          >
            <MenuItem value={''}>Не выбрано</MenuItem>
            {statuses?.list?.map(status => (
              <MenuItem key={status?.eventTypeCode} value={status?.eventTypeCode}>
                {status?.eventTypeName}
              </MenuItem>
            ))}
          </SelectPlaceholder>
        </Grid>

        {events?.eventTypeCode && (
          <Grid item xs={12} className={classes.item}>
            <InputLabel shrink className={classes.inputLabel}>
              Выбрать результат
            </InputLabel>
            <SelectPlaceholder
              IconComponent={props => <ExpandMoreIcon {...props} style={{ margin: '0 8px 0 8px' }} />}
              value={events?.eventResultCode || null}
              name={'eventResultCode'}
              onChange={e => contractStoreFunc.handleEventsChange(e)}
              fullWidth
              placeholder={'Результат'}
            >
              <MenuItem value={''}>Не выбрано</MenuItem>
              {(selectedEvent?.eventResultList || []).map(result => (
                <MenuItem key={result?.code} value={result?.code}>
                  {result?.name}
                </MenuItem>
              ))}
            </SelectPlaceholder>
          </Grid>
        )}
        {events?.eventResultCode === 'HANDED_OVER_TO_COURT' && (
          <>
            <Card variant="outlined" className={classes.card}>
              <IconButton className={classes.icon} component="label">
                <UploadIcon />
                <input
                  type="file"
                  hidden
                  onChange={handleUploadFile}
                  ref={fileInputRef}
                  disabled={files?.length === 1}
                />
              </IconButton>
              <Grid item className={classes.textWrapper} onClick={handleClick}>
                <Typography className={files?.length === 1 ? classes.disabledTitle : classes.title}>
                  Нажмите, чтобы загрузить досье клиента
                </Typography>
                <Typography className={classes.subtitle}>или перетащите документ в эту область</Typography>
              </Grid>
            </Card>

            {(files || []).map(file => (
              <Grow key={file.name} in={file.name} timeout={500}>
                <Grid item container className={classes.fileContainer}>
                  <Grid item className={classes.fileIcon}>
                    <FileIcon />
                    <Box className={classes.blueLines}>
                      <BlueLines />
                    </Box>
                  </Grid>
                  <Grid item xs={10}>
                    <Grid item className={classes.fileWrapper}>
                      <Grid item>
                        <Typography variant={'body2'} className={classes.label}>
                          {file.name}
                        </Typography>
                        <Typography variant={'body2'} className={classes.date}>
                          {file.date}
                        </Typography>
                      </Grid>
                      <IconButton onClick={() => handleDelete(file.name)}>
                        <DeleteIcon className={classes.actionBtn} />
                      </IconButton>
                    </Grid>
                    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                      <Box width="100%" mr={1}>
                        <BorderLinearProgress variant="determinate" value={file.progress} />
                      </Box>
                      <Box minWidth={35}>
                        <Typography variant="body2">{`${Math.round(file.progress)}%`}</Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Grow>
            ))}
          </>
        )}
        {events?.eventResultCode === 'PROMISE' && (
          <Grid item xs={12} className={classes.item}>
            <DatePicker
              label="Дата"
              placeholder="Выберите дату"
              format="dd.MM.yyyy"
              disablePast
              name="dueDate"
              value={events?.dueDate}
              required
              fullWidth
              onChange={contractStoreFunc.handleChangeEventsDate}
              InputProps={{
                endAdornment: (
                  <InputAdornment position={'start'}>
                    <DateIcon
                      style={{
                        color: GRAY_COLORS[500]
                      }}
                    />
                  </InputAdornment>
                )
              }}
              KeyboardButtonProps={{
                'aria-label': 'change date'
              }}
            />
          </Grid>
        )}
        <Grid item xs={12} className={classes.item}>
          <InputLabel shrink className={classes.inputLabel}>
            Комментарий
          </InputLabel>
          <TextField
            minRows={5}
            value={events?.description}
            name={'description'}
            onChange={e => contractStoreFunc.handleEventsChange(e)}
            fullWidth
            multiline
            placeholder={'Напишите комментарий...'}
          />
        </Grid>
        {isNoResult && (
          <Grid item xs={12} className={classes.item}>
            <Typography className={classes.isNoResult}>У вас есть незавершённое действие</Typography>
          </Grid>
        )}
      </Grid>
    </ActionModal>
  )
}
